import ET3Div from "../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import ClientChevron from "./ClientChevron";
import ClientUserName from "./ClientUserName";
import ClientSubscriptionStatus from "./ClientSubscriptionStatus";
import ClientConversations from "./client-conversations";
import ClientPersonalInfo from "./ClientPersonalInfo";
import ConversationMarker from "./ConversationMarker";
import getKhattabatSelectsStore from "../../../stores/khattabat-stores/selects-store";
import getCorePersonalStore from "../../../stores/core/core-personal-store";
import getKhattabat101CStore from "../../../stores/khattabat-stores/101c-stores/index";

const Client = withLiteObserverAndTheme<{
  userID: number;
}>((props) => {
  const { theme, userID } = props;
  const { colors, unitX } = theme;
  const isMarkedConversation =
    getKhattabatSelectsStore().isMarkedConversation(userID);
  const {
    oneOTwoCounter,
    residenceCoutry,
    originCountry,
    age,
    height,
    weight,
    lastLogin,
    applicationStatus,
    marriageType,
    userName,
    isSilentBanned
  } = getKhattabat101CStore(userID);

  const borderColors = isMarkedConversation
    ? colors.all.green
    : colors.all.transparent;
  const isAiKhattaba = getCorePersonalStore().isKhattabaAiAdmin.get();

  return (
    <ET3Div
      width={1510}
      height={0}
      alignItems={"center"}
      fDirection={"column"}
      style={{}}
      color={""}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={true}
      isScrollable={false}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        fDirection="row"
        justifyContent="space-between"
        alignItems="center"
        withShadow={true}
        width={1510}
        height={80}
        color={colors.all.white}
        style={{
          borderRadius: 30 * unitX,
          overflow: "hidden",
          border: `1px solid ${borderColors}`
        }}
        onClick={() => {}}
      >
        <ConversationMarker userID={userID} />
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          fDirection="row"
          justifyContent="flex-start"
          alignItems="center"
          withShadow={false}
          width={400}
          height={80}
          color={colors.all.white}
          style={{}}
          onClick={() => {}}
        >
          <Et3Margin left={1} top={0} bottom={0} right={1} />
          <ClientUserName
            userID={userID}
            userName={userName.get()}
            isSilentBanned={isSilentBanned.get()}
          />
          {isAiKhattaba ? null : <ClientSubscriptionStatus userID={userID} />}
        </ET3Div>
        {isAiKhattaba ? null : (
          <ClientPersonalInfo
            information={`${oneOTwoCounter.get()}`}
            title={"102 Counter"}
          />
        )}
        <ClientPersonalInfo
          information={residenceCoutry.get()}
          title={"Location"}
        />
        <ClientPersonalInfo
          information={originCountry.get()}
          title={"Nationality"}
        />
        <ClientPersonalInfo information={`${age.get()}`} title={"Age"} />
        <ClientPersonalInfo information={`${height.get()}`} title={"Height"} />
        <ClientPersonalInfo information={`${weight.get()}`} title={"Weight"} />
        <ClientPersonalInfo
          information={lastLogin.get()}
          title={"Last Login"}
        />
        {!isAiKhattaba ? null : (
          <ClientPersonalInfo
            information={applicationStatus.get()}
            title={"Status"}
          />
        )}
        <ClientPersonalInfo information={`${marriageType.get()}`} title={""} />
        <ClientChevron userID={userID} />
      </ET3Div>

      <Et3Margin top={10} bottom={10} left={0} right={0} />
      <ClientConversations clientID={userID} />
      <Et3Margin top={25} bottom={25} left={0} right={0} />
    </ET3Div>
  );
});
export default Client;
